import React, { Fragment } from 'react';
import { Check } from 'react-feather';
import Avatar from '../atoms/avatar';
import { useMessages } from '@hooks/useMessages';

interface Props {
  title?: string;
  message: string;
}

const SuccessToast: React.FC<Props> = ({ title, message }) => {
  const { messages } = useMessages();
  return (
    <>
      <div className="toastify-header">
        <div className="title-wrapper">
          <Avatar size="sm" color="success" icon={<Check size={12} />} />
          <h6 className="toast-title">{title || messages('title_success')}</h6>
        </div>
      </div>
      <div className="toastify-body">
        <span role="img" aria-label="toast-text">
          {message}
        </span>
      </div>
    </>
  );
};
export default SuccessToast;
